/*jshint esversion: 11 */
import axios from 'axios';
const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_HOST_URL,
  timeout: 1000000
});

instance.interceptors.request.use((req) => {
  const access_token = window.localStorage.getItem('ACCESS_TOKEN');
  const user_details = window.localStorage.getItem('user_details');
  if (access_token) {
    req.headers.Authorization = `Bearer ${access_token}`;
  }
  try {
    if (user_details) {
      const parsed_user_details = JSON.parse(user_details);
      req.baseURL = req.baseURL + `/${parsed_user_details?.user_type}`;
    }
  } catch (e) {}
  return req;
});

export default instance;
